import { useEffect, useState } from "react";

let deferredPrompt = null;
let installed = false;
const listeners = new Set();

function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  return Boolean(
    window.matchMedia?.("(display-mode: standalone)")?.matches
    || window.navigator?.standalone === true
  );
}

function snapshot() {
  return {
    canPrompt: Boolean(deferredPrompt?.prompt),
    isStandalone: installed || isStandaloneDisplay(),
  };
}

function emit() {
  const next = snapshot();
  listeners.forEach(listener => listener(next));
}

if (typeof window !== "undefined") {
  installed = isStandaloneDisplay();

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    installed = false;
    emit();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    installed = true;
    emit();
  });
}

export function getPwaInstallSnapshot() {
  return snapshot();
}

export function subscribeToPwaInstall(listener) {
  listeners.add(listener);
  listener(snapshot());
  return () => listeners.delete(listener);
}

export async function promptPwaInstall() {
  if (!deferredPrompt?.prompt) {
    return { prompted: false, outcome: null };
  }

  const promptEvent = deferredPrompt;
  await promptEvent.prompt();
  const choice = await promptEvent.userChoice?.catch(() => null);
  deferredPrompt = null;
  emit();
  return { prompted: true, outcome: choice?.outcome || null };
}

export function usePwaInstall() {
  const [state, setState] = useState(getPwaInstallSnapshot);

  useEffect(() => subscribeToPwaInstall(setState), []);

  return {
    ...state,
    installApp: promptPwaInstall,
  };
}
